import api from "@/api";

const state = {
    cubejsToken: localStorage.getItem("cubejs_token"),
};

const getters = {
    cubejsToken(state) {
        return state.cubejsToken;
    }
};

const actions = {
    async fetchCubejsToken({
        commit
    }) {
        const v2 = api();
        const {
            data
        } = await v2.get("/rmc/analytics/token");

        localStorage.setItem("cubejs_token", data.jwt);
        commit("SET_CUBEJS_TOKEN", data.jwt);
    },
    revokeCubejsToken({
        commit
    }) {
        localStorage.removeItem("cubejs_token");
        commit("REVOKE_CUBEJS_TOKEN");
    }
};

const mutations = {
    SET_CUBEJS_TOKEN(state, cubejsToken) {
        state.cubejsToken = cubejsToken;
    },
    REVOKE_CUBEJS_TOKEN(state) {
        state.cubejsToken = null;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
};